import React from 'react';
import Scores from '../scores';
import TestDate from '../test-date';

const ActForm = () => (
  <>
    <p className="shared-font body">
      Only select this option if you took the ACT before September 2025, when the Science section
      was required and included in the composite score.
    </p>
    <TestDate />
    <Scores min={1} max={36} />
  </>
);

export default ActForm;
